import useSessionWatcher from "../hooks/useSessionWatcher";

const SessionWatcher = () => {
    useSessionWatcher();
    return null;
};

export default SessionWatcher;